import React, { useState, Fragment, useEffect } from 'react';
import { Stepper, Container } from '@mui/material';
import { Box, ThemeProvider, createTheme } from '@mui/system';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PortfolioAdd from './PortfolioAdd'
import { Link } from "react-router-dom";
import TransactionAddDialog from "./TransactionAddDialog";
import { useDispatch, useSelector } from "react-redux";
import { getPortfolio, isEmptyProfile } from "../store/actions";
import ButtonGroup from '@material-ui/core/ButtonGroup';
import EmptyPortfolio from "./EmptyPortfolio";
const steps = ['Как это работает', 'Портфель', 'Данные'];
const description = ['', 'Создайте портфель', 'Добавьте сделки'];

export default function HorizontalLinearStepper() {
    const [activeStep, setActiveStep] = useState(0);

    const portfolioList = useSelector(store => store.portfolios?.list);
    const isLoading = useSelector(store => store.portfolios?.isLoad)
    const data = useSelector(store => store.portfolio?.data)

    const dispatch = useDispatch();
    // useEffect(() => {
    //     if (!isLoading){
    //         if (portfolioList.length > 0) {
    //             dispatch(getPortfolio(portfolioList[0]?.id))
    //         }
    //     }
    // }, [isLoading,portfolioList]);

    // useEffect(() => {
    //     if (activeStep==2){
    //         if (portfolioList.length > 0) {
    //             dispatch(getPortfolio(portfolioList[0]?.id))
    //         }
    //     }
    // }, [activeStep,portfolioList]);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    const handleExit = () => {
        dispatch(isEmptyProfile(true))
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleReset = () => {
        setActiveStep(0);
    };
    const getChildVal = (value) => {
        if (value) {
            if (portfolioList.length > 0) {
                dispatch(getPortfolio(portfolioList[0]?.id))
            }
            handleNext()
        }
    }
    return (
        <Container

            // sx={{ mt:10}}
            maxWidth="sm"
        >
            <Typography textAlign='center' sx={{ mt: 10, mb: 10 }} variant="h4" >Добро пожаловать!</Typography>
            <Stepper activeStep={activeStep} sx={{ alignSelf: "end", mb: 10 }}>
                {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    labelProps.optional = (
                        <Typography variant="caption">{description[index]}</Typography>
                    );
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            {activeStep === 0 &&
                <Fragment>
                    <Typography textAlign='center' sx={{ mt: 10, mb: 2 }} variant="h5" >Привет, инвестор✌🏻</Typography>
                    <Typography textAlign='center'>Возьмите под контроль свои инвестиции всего за пару шагов 👍🏻</Typography>
                    <Typography textAlign='center' sx={{ mt: 2, mb: 2 }}>И присоединяйтесь в <a href="https://t.me/investmonitoring_ru" target="_blank">наш чат в Телеграм</a></Typography>
                    <Box alignContent="flex-end">
                        <Button size="large" sx={{ mr: 1 }} onClick={handleNext} fullWidth variant="outlined" color="primary" >
                            Начать
                        </Button>
                    </Box>
                </Fragment>
            }
            {activeStep === 1 &&
                <Fragment>
                    <PortfolioAdd action={getChildVal} />
                </Fragment>
            }
            {activeStep === 2 &&
                <Fragment>
                    <EmptyPortfolio />
                    {/*<Box alignContent="flex-end">*/}
                    {/*    <Button size="large" sx={{ mr: 1, mt:2, height: 80 }} onClick={handleExit} to={"/main/portfolio"} component={Link} fullWidth variant="outlined" color="primary" >*/}
                    {/*        Добавить сделку вручную*/}
                    {/*    </Button>*/}
                    {/*    <Button size="large" sx={{ mr: 1, mt:2, height: 80 }} to={"/main/transactions"} component={Link} fullWidth variant="outlined" color="primary" >*/}
                    {/*        Загрузить отчеты брокеры*/}
                    {/*    </Button>*/}
                    {/*</Box>*/}
                </Fragment>
            }
            {/*{activeStep === steps.length ? (*/}
            {/*    <Fragment>*/}
            {/*        <Typography sx={{ mt: 2, mb: 1 }}>*/}
            {/*            All steps completed - you&apos;re finished*/}
            {/*        </Typography>*/}
            {/*        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>*/}
            {/*            <Box sx={{ flex: '1 1 auto' }} />*/}
            {/*            <Button onClick={handleReset}>Сбросить</Button>*/}
            {/*        </Box>*/}
            {/*    </Fragment>*/}
            {/*) : (*/}
            {/*    <Fragment>*/}
            {/*        <Box style={{width: '100%',*/}
            {/*            position: 'fixed',*/}
            {/*            bottom: 80}}*/}
            {/*             justifyContent="space-around"*/}
            {/*             sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>*/}
            {/*            <Button*/}
            {/*                color="inherit"*/}
            {/*                disabled={activeStep === 0}*/}
            {/*                onClick={handleBack}*/}
            {/*                sx={{ mr: 1 }}*/}
            {/*            >*/}
            {/*                Назад*/}
            {/*            </Button>*/}
            {/*            <Button onClick={handleNext}>*/}
            {/*                {activeStep === steps.length - 1 ? 'Завершить' : 'Далее'}*/}
            {/*            </Button>*/}
            {/*        </Box>*/}
            {/*        <Button sx={{ mr: 1 }} onClick={handleNext} fullWidth variant="outlined" color="primary" style={{position: 'fixed',bottom: 80}}>*/}
            {/*            {activeStep === steps.length - 1 ? 'Завершить' : 'Далее'}*/}
            {/*        </Button>*/}
            {/*    </Fragment>*/}
            {/*)}*/}
        </Container>
    );
}
